import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import {
  AdminDndEmail,
  CreateAdminDndEmail,
  DndEmail,
} from '../models/dnd-email';
import { PaginatedResponse } from '../../../../shared/interfaces/pagination';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DndEmailService {
  private apiUrl = environment.apiBaseUrl;
  private http = inject(HttpClient);

  getDndEmail() {
    return this.http.get<DndEmail>(`${this.apiUrl}/api/email/dnd`);
  }

  disableDnd() {
    return this.http.delete<void>(`${this.apiUrl}/api/email/dnd`);
  }

  getDndEmails(
    page: number,
    pageSize: number,
    search?: string,
  ): Observable<PaginatedResponse<AdminDndEmail>> {
    let params = new HttpParams();
    params = params.set('page', page.toString());
    params = params.set('page_size', pageSize.toString());
    if (search) {
      params = params.set('search', search);
    }
    return this.http.get<PaginatedResponse<AdminDndEmail>>(
      `${this.apiUrl}/api/admin/emails/dnd`,
      { params },
    );
  }

  addDndEmail(payload: CreateAdminDndEmail) {
    return this.http.post<void>(`${this.apiUrl}/api/admin/emails/dnd`, payload);
  }

  deleteDndEmail(id: number) {
    return this.http.delete<void>(`${this.apiUrl}/api/admin/emails/dnd/${id}`);
  }
}
